import { INSURANCE_LIST_LOADING, INSURANCE_LIST_DONE, INSURANCE_LIST_ERROR } from './actions'

export default {
  [INSURANCE_LIST_LOADING] (state) {
    state.isLoadingInsuranceList = true
  },

  [INSURANCE_LIST_DONE] (state, insurance) {
    state.insuranceList = insurance.data
    state.isLoadingInsuranceList = false
  },

  [INSURANCE_LIST_ERROR] (state, error) {
    state.errorInsuranceList = error
    state.isLoadingInsuranceList = false
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/insurance/mutations.js